// Dependencies
import React from 'react';

// Components
import { Typography } from '../../../display/Typography';

// Styles
import { AvatarContainer } from './styles';

// Types
import { UserButtonProps } from './types';

const UserButton = ({ initials, className }: UserButtonProps) => {
  const getInitials = (userName: string) => {
    // Limpiar espacios extra y dividir por espacios
    const fullNameArr = userName
      .trim()
      .split(' ')
      .filter((word) => word.length > 0);

    // Si solo hay una palabra, usar las dos primeras letras
    if (fullNameArr.length === 1) {
      const word = fullNameArr[0];
      return `${word[0].toUpperCase()}${word[1].toUpperCase()}`;
    }

    // Si hay dos o más palabras, usar la primera letra de las dos primeras
    return `${fullNameArr[0][0].toUpperCase()}${fullNameArr[1][0].toUpperCase()}`;
  };

  return (
    <AvatarContainer className={className}>
      <Typography colorText="white" size="M">
        {getInitials(initials)}
      </Typography>
    </AvatarContainer>
  );
};

export default UserButton;
